export enum StateType {
  CREATE,
  CONFIRM,
  SIGN_IN,
}
